<template>
  <li v-if="phases && phases.length" class="dropdown">
    <a href="#" class="nolink">Fáze a oblasti</a>
    <Dropdown :items="phases" :bind-key="'id'">
      <template v-slot:item="{ item }">
        <a
          href="#"
          :class="{ nolink: true, active: selectedPhaseId === item.id }"
          >{{ item.name }}</a
        >
        <Dropdown
          :items="areas[item.id]"
          :bind-key="'areaId'"
          class="dropdown__list--sub"
        >
          <template v-slot:item="{ item }">
            <a
              :href="item.url"
              :title="`Otevřít oblast ${item.name}`"
              v-on:mouseover="(event) => visit(item, true)"
              v-on:mouseleave="(event) => visit(item, false)"
            >
              {{ item.name }}
            </a>
          </template>
        </Dropdown>
      </template>
    </Dropdown>
  </li>
</template>
<script>
import Dropdown from '@/components/menu/Dropdown.vue';

export default {
  props: ['phases', 'areas'],
  components: {
    Dropdown
  },
  data() {
    return {
      selectedPhaseId: undefined
    };
  },
  methods: {
    visit: function (item, active) {
      this.selectedPhaseId = active ? item.phaseId : undefined;
    }
  }
};
</script>

<style>
.active {
  font-weight: bold;
}
</style>
